
<div
  :class="
    classes(
      n(),
      n(`--${mergedLayout}`),
      {
        [n('--error')]: hasError,
        [n('--focused')]: isFocused,
        [n('--disabled')]: mergedDisabled,
        [n('--borderless')]: !bordered,
      }
    )
  "
  @focusin="handleFocusin"
  @focusout="handleFocusout"
>
  <!-- 小标题区域 -->
  <div
    v-if="subtitle || $slots.subtitle"
    :class="n('subtitle')"
  >
    <slot name="subtitle">
      {{ subtitle }}
    </slot>
  </div>

  <!-- 主区域容器 -->
  <div :class="n('wrapper')">
    <div :class="n('row')">
      <!-- 标签 -->
      <div
        v-if="label || $slots.label"
        :class="n('label')"
        :style="labelStyle"
      >
        <span
          v-if="required"
          :class="n('required')"
        >*</span>
        <slot name="label">
          {{ label }}
        </slot>
      </div>

      <!-- 控件区域 -->
      <div :class="n('control')">
        <slot />
      </div>
    </div>

    <!-- 错误提示（底线上方） -->
    <div
      v-if="shouldShowError && currentErrorMessage"
      :class="n('error')"
    >
      <slot
        name="error"
        :error-message="currentErrorMessage"
      >
        {{ currentErrorMessage }}
      </slot>
    </div>
  </div>

  <!-- 辅助说明（底线下方） -->
  <div
    v-if="tips || $slots.tips"
    :class="n('tips')"
  >
    <slot name="tips">
      {{ tips }}
    </slot>
  </div>
</div>
